<div class="main-content">
  <app-header />
  <div class="row mt-5">
    <div class="col-12">
      <div class="d-flex justify-content-between">
        <app-profile [mode]="'final-user'" [username]="companyName" />
        <div class="btns-wrapper align-items-center">
          <button
            [ngClass]="{
              'button-show': activeTab === 'machines',
              'button-hide': activeTab !== 'machines',
              light: isLight,
              dark: !isLight
            }"
            (click)="activeTab = 'machines'"
          >
            {{ 'FINAL_USER_DASHBOARD.BUTTONS.MACHINES' | translate }}
          </button>
          <button
            [ngClass]="{
              'button-show': activeTab === 'tickets',
              'button-hide': activeTab !== 'tickets',
              light: isLight,
              dark: !isLight
            }"
            (click)="activeTab = 'tickets'"
          >
            {{ 'FINAL_USER_DASHBOARD.BUTTONS.TICKETS' | translate }}
          </button>
          <button
            [ngClass]="{
              'button-show': activeTab === 'requests',
              'button-hide': activeTab !== 'requests',
              light: isLight,
              dark: !isLight
            }"
            (click)="activeTab = 'requests'"
          >
            {{ 'FINAL_USER_DASHBOARD.BUTTONS.REQUESTS' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <hr />
  <h1 class="mt-5">
    {{ 'FINAL_USER_DASHBOARD.title_' + activeTab | translate }}
  </h1>
  <p class="final-user-dashboard-subtitle">{{ 'FINAL_USER_DASHBOARD.subtitle_' + activeTab | translate }}</p>
  @if (activeTab === 'machines') {
    @if (alerts$ | async; as alerts) {
      <div class="row mt-5">
        <div class="col-12">
          @if (alerts.hasAlerts) {
            <app-icam-container
              [iconName]="'bell'"
              [iconColor]="'white'"
              fixedTheme="dark"
              [isExpandable]="true"
              (toggleShow)="isOpen = !isOpen"
            >
              @if (!isOpen) {
                <app-icam-machine-alert-warning-recap [machines]="alerts.machines" [contracts]="alerts.contracts">
                </app-icam-machine-alert-warning-recap>
              } @else {
                @for (machineKo of alerts.machines; track machineKo) {
                  <app-icam-machine-alert [machine]="machineKo" />
                }
                @for (contract of alerts.contracts; track contract) {
                  <app-icam-machine-warranty-warning [contract]="contract" />
                }
              }
            </app-icam-container>
          }
        </div>
      </div>
    }
  }

  <div class="row mt-5">
    <div class="col-12">
      @if (activeTab === 'machines' && machines$ && machineFilters$) {
        <app-icam-container [iconName]="'list'" [iconColor]="'white'">
          <app-table
            [type]="'machines'"
            [allValues$]="machines$"
            [filters$]="machineFilters$"
            [hasChart]="false"
            (selectedFilter)="onSelectedFilter($event, 'machines')"
            [prevPage]="prevPageMachines"
            [currentPage]="currentPageMachines"
            [nextPage]="nextPageMachines"
            (selectedPage)="onChangePageMachines($event)"
            [useInlineKeywordFilter]="true"
          />
        </app-icam-container>
      }

      @if (activeTab === 'tickets') {
        <app-icam-container [iconName]="'ticket'" [iconColor]="'white'" class="my-5">
          <app-table
            [allValues$]="openedTickets$"
            [type]="'open_tickets'"
            [hasChart]="false"
            (selectedPage)="onChangePageOpenedTicket($event)"
            [prevPage]="prevPageTicketOpened"
            [currentPage]="currentPageTicketOpened"
            [nextPage]="nextPageTicketOpened"
            [totalPages]="totalPagesTicketOpened"
            [useInlineKeywordFilter]="true"
          />
          <div class="py-4"></div>
          <app-table
            [allValues$]="closedTickets$"
            [type]="'closed_tickets'"
            (selectedFilter)="onSelectedFilter($event, 'closed_tickets')"
            [hasChart]="false"
            [filters$]="ticketFilter$"
            (selectedPage)="onChangeClosedTicket($event)"
            [prevPage]="prevPageTicketClosed"
            [currentPage]="currentPageTicketClosed"
            [nextPage]="nextPageTicketClosed"
            [totalPages]="totalPagesTicketClosed"
            [useInlineKeywordFilter]="true"
          />
        </app-icam-container>
      }

      @if (activeTab === 'requests') {
        <app-icam-container [iconName]="'info-circle'" [iconColor]="'white'">
          <app-table
            [type]="'requests'"
            [allValues$]="requestInfo$"
            (selectedFilter)="onSelectedFilter($event, 'requests')"
            [hasChart]="false"
            [filters$]="requestInfoFilter$"
            (selectedPage)="onChangeRequestInfo($event)"
            [prevPage]="prevPageRequestInfo"
            [currentPage]="currentPageRequestInfo"
            [nextPage]="nextPageRequestInfo"
            [totalPages]="totalPagesRequestInfo"
            [useInlineKeywordFilter]="true"
          />
        </app-icam-container>
      }
    </div>
  </div>
  <div class="mt-5 pb-3" id="icamRights">
    <span> &copy; {{ getYear() }} ICAM S.P.A - All rights reserved </span>
  </div>
</div>
